export default "__VITE_ASSET__UOGxxuZU__"